"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("../assets/css/font-face.css");

require("./PaginateArrows.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var PaginateArrows = function PaginateArrows(_ref) {
  var currentPage = _ref.currentPage,
      totalItems = _ref.totalItems,
      perPage = _ref.perPage,
      onClick = _ref.onClick,
      fullWidth = _ref.fullWidth,
      className = _ref.className;

  var _useState = (0, _react.useState)(currentPage),
      _useState2 = _slicedToArray(_useState, 2),
      current = _useState2[0],
      setCurrent = _useState2[1];

  (0, _react.useEffect)(function () {
    setCurrent(currentPage);
  }, [currentPage]);
  var pagesTotal = 0;

  if (totalItems % perPage > 0) {
    pagesTotal = parseInt(totalItems / perPage) + 1;
  } else {
    pagesTotal = totalItems / perPage;
  }

  var from = current * perPage - perPage + 1;
  var to = current * perPage;

  var renderPageInfo = function renderPageInfo() {
    var limitedTo = to > totalItems ? totalItems : to;
    return "".concat(from, "-").concat(limitedTo, " de ").concat(totalItems);
  };

  var increaseCurrentPage = function increaseCurrentPage() {
    if (current + 1 > pagesTotal) return;
    onClick(current + 1);
    setCurrent(current + 1);
  };

  var decreaseCurrentPage = function decreaseCurrentPage() {
    if (current <= 1) return;
    onClick(current - 1);
    setCurrent(current - 1);
  };

  var nextArrowClass = 'paginate__arrow paginate__arrow-next';
  var prevArrowClass = 'paginate__arrow paginate__arrow-prev';
  var wrapperClass = 'paginate-arrows';
  if (current + 1 > pagesTotal) nextArrowClass += ' paginate__arrow--disabled';
  if (current <= 1) prevArrowClass += ' paginate__arrow--disabled';
  if (fullWidth) wrapperClass += ' paginate-arrows--full';
  if (className) wrapperClass += " ".concat(className);
  return _react.default.createElement("div", {
    className: wrapperClass
  }, pagesTotal > 1 && _react.default.createElement("span", {
    className: prevArrowClass,
    onClick: decreaseCurrentPage
  }), _react.default.createElement("span", {
    className: "paginate__info"
  }, renderPageInfo()), pagesTotal > 1 && _react.default.createElement("span", {
    className: nextArrowClass,
    onClick: increaseCurrentPage
  }));
};

PaginateArrows.defaultProps = {
  onClick:
  /* istanbul ignore next */
  function onClick() {}
};
PaginateArrows.propTypes = {
  onClick: _propTypes.default.func
};
var _default = PaginateArrows;
exports.default = _default;